

export type EndorsementsTabsKeyValues = ENDORSEMENTS_TABS_KEY_VALUES; 
export enum ENDORSEMENTS_TABS_KEY_VALUES {
    ENDORSEMENTS_ELEVATORS_BOILERS = '1',
    ENDORSEMENTS_CARS = '2',
}